import { render } from "./BaseButtonCancel.vue?vue&type=template&id=1baae5e4"
import script from "./BaseButtonCancel.vue?vue&type=script&lang=js"
export * from "./BaseButtonCancel.vue?vue&type=script&lang=js"
script.render = render

export default script